import { checkIsToggleEnabled } from '@base/utils/toggle-utils';

export default {
  getToggles: (state) => state.toggles,
  isToggleEnabled: (state) => (name, options) => checkIsToggleEnabled(name, state.toggles, options),
};
